import React from "react";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { useT } from "@/context/LanguageContext";

export function PageHero({ overline, title, subtitle, crumbs = [], image }) {
  const { t } = useT();
  return (
    <section className="relative overflow-hidden bg-ink pt-32 pb-16 lg:pt-40 lg:pb-20" data-testid="page-hero">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/90 to-[#0A192F]/60" />
        </>
      )}
      <div className="absolute -right-20 top-10 h-64 w-64 rounded-full bg-teal/15 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <nav className="mb-5 flex items-center gap-1 text-xs text-slate-400" data-testid="breadcrumbs">
          <Link to="/" className="hover:text-teal">{t("countryPage.home")}</Link>
          {crumbs.map((c) => (
            <span key={c.label} className="flex items-center gap-1">
              <CaretRight size={12} />
              {c.to ? <Link to={c.to} className="hover:text-teal">{c.label}</Link> : <span className="text-slate-300">{c.label}</span>}
            </span>
          ))}
        </nav>
        {overline && <p className="text-xs uppercase tracking-[0.25em] font-semibold text-teal-light">{overline}</p>}
        <h1 className="mt-3 max-w-3xl font-heading text-4xl font-bold leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300">{subtitle}</p>}
      </div>
    </section>
  );
}
